import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ComponentRef,
} from "@angular/core";
import { NzButtonSize } from "ng-zorro-antd/button";

@Component({
  selector: "app-back-button",
  templateUrl: "./back-button.component.html",
  styleUrls: ["./back-button.component.css"],
})
export class BackButtonComponent implements OnInit {
  @Output() onClick = new EventEmitter();
  size: NzButtonSize = "default";

  ngOnInit(): void {}

  historyBack() {
    window.history.back();
  }
}
